var _metadata, _defs, _clipPath, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeedyKnobComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg125",
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    stroke: "none",
    fill: "none",
    viewBox: "0.0 0.0 348.0 348.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata131"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs129"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    clipRule: "nonzero",
    d: "m0 0l348.0 0l0 348.0l-348.0 0l0 -348.0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g119",
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5",
    fillRule: "nonzero",
    d: "M 0,0 H 348 V 348 H 0 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    fillRule: "nonzero",
    d: "M -6,0 H 348.01575 V 347.9685 H -6 Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    fillRule: "nonzero",
    d: "m 5.07874,5.7758217 h 336.9134 V 343.44512 H 5.07874 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    fillRule: "nonzero",
    d: "m 5.07874,5.7758217 h 336.9134 V 343.44512 H 5.07874 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    fillRule: "nonzero",
    d: "m 133.84251,15.666667 h 74.33072 v 56.881886 h -74.33072 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    fillRule: "nonzero",
    d: "m 154.53912,44.089794 q 0,-4.0625 0.82812,-6.53125 0.84375,-2.484375 2.48438,-3.828125 1.65625,-1.34375 4.15625,-1.34375 1.84375,0 3.23437,0.75 1.39063,0.734375 2.29688,2.140625 0.90625,1.390625 1.42187,3.40625 0.51563,2 0.51563,5.40625 0,4.03125 -0.82813,6.515625 -0.82812,2.46875 -2.48437,3.828125 -1.64063,1.34375 -4.15625,1.34375 -3.3125,0 -5.20313,-2.375 -2.26562,-2.859375 -2.26562,-9.3125 z m 2.89062,0 q 0,5.640625 1.3125,7.515625 1.32813,1.859375 3.26563,1.859375 1.9375,0 3.25,-1.875 1.32812,-1.875 1.32812,-7.5 0,-5.65625 -1.32812,-7.515625 -1.3125,-1.859375 -3.28125,-1.859375 -1.9375,0 -3.09375,1.640625 -1.45313,2.09375 -1.45313,7.734375 z m 14.90625,0 q 0,-4.0625 0.82813,-6.53125 0.84375,-2.484375 2.48437,-3.828125 1.65625,-1.34375 4.15625,-1.34375 1.84375,0 3.23438,0.75 1.39062,0.734375 2.29687,2.140625 0.90625,1.390625 1.42188,3.40625 0.51562,2 0.51562,5.40625 0,4.03125 -0.82812,6.515625 -0.82813,2.46875 -2.48438,3.828125 -1.64062,1.34375 -4.15625,1.34375 -3.3125,0 -5.20312,-2.375 -2.26563,-2.859375 -2.26563,-9.3125 z m 2.89063,0 q 0,5.640625 1.3125,7.515625 1.32812,1.859375 3.26562,1.859375 1.9375,0 3.25,-1.875 1.32813,-1.875 1.32813,-7.5 0,-5.65625 -1.32813,-7.515625 -1.3125,-1.859375 -3.28125,-1.859375 -1.9375,0 -3.09375,1.640625 -1.45312,2.09375 -1.45312,7.734375 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    fillRule: "nonzero",
    d: "m 145.80315,164.96063 v 0 c 0,-15.7075 12.41617,-28.44095 27.73228,-28.44095 v 0 c 7.35506,0 14.40888,2.99645 19.6097,8.33016 5.20081,5.33372 8.12259,12.56778 8.12259,20.11079 v 0 c 0,15.7075 -12.41617,28.44095 -27.73229,28.44095 v 0 c -15.31611,0 -27.73228,-12.73345 -27.73228,-28.44095 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    fillRule: "nonzero",
    d: "m 145.80315,164.96063 v 0 c 0,-15.7075 12.41617,-28.44095 27.73228,-28.44095 v 0 c 7.35506,0 14.40888,2.99645 19.6097,8.33016 5.20081,5.33372 8.12259,12.56778 8.12259,20.11079 v 0 c 0,15.7075 -12.41617,28.44095 -27.73229,28.44095 v 0 c -15.31611,0 -27.73228,-12.73345 -27.73228,-28.44095 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    fillRule: "nonzero",
    d: "m 148.85039,82.88714 h 52.40945 v 48.00001 h -52.40945 z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    fillRule: "nonzero",
    d: "m 39.766403,202.43307 v 0 c 0,-8.019 6.789761,-14.51968 15.165356,-14.51968 v 0 c 4.022102,0 7.879467,1.52974 10.723522,4.25271 2.844055,2.72296 4.441834,6.41611 4.441834,10.26697 v 0 c 0,8.019 -6.789761,14.51968 -15.165357,14.51968 v 0 c -8.375595,0 -15.165356,-6.50068 -15.165355,-14.51968 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    fillRule: "nonzero",
    d: "m 39.766403,202.43307 v 0 c 0,-8.019 6.789761,-14.51968 15.165356,-14.51968 v 0 c 4.022102,0 7.879467,1.52974 10.723522,4.25271 2.844055,2.72296 4.441834,6.41611 4.441834,10.26697 v 0 c 0,8.019 -6.789761,14.51968 -15.165357,14.51968 v 0 c -8.375595,0 -15.165356,-6.50068 -15.165355,-14.51968 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    fillRule: "nonzero",
    d: "m 85.020996,242.1378 v 0 c 0,-8.01901 6.789764,-14.5197 15.165354,-14.5197 v 0 c 4.0221,0 7.87947,1.52976 10.72352,4.25273 2.84406,2.72296 4.44184,6.41611 4.44184,10.26697 v 0 c 0,8.019 -6.78977,14.51967 -15.16536,14.51967 v 0 c -8.375589,0 -15.165354,-6.50067 -15.165354,-14.51967 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    fillRule: "nonzero",
    d: "m 85.020996,242.1378 v 0 c 0,-8.01901 6.789764,-14.5197 15.165354,-14.5197 v 0 c 4.0221,0 7.87947,1.52976 10.72352,4.25273 2.84406,2.72296 4.44184,6.41611 4.44184,10.26697 v 0 c 0,8.019 -6.78977,14.51967 -15.16536,14.51967 v 0 c -8.375589,0 -15.165354,-6.50067 -15.165354,-14.51967 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    fillRule: "nonzero",
    d: "m 132.69423,280.22964 v 0 c 0,-8.01898 6.78976,-14.51968 15.16534,-14.51968 v 0 c 4.02211,0 7.87947,1.52975 10.72353,4.25271 2.84406,2.72299 4.44183,6.41611 4.44183,10.26697 v 0 c 0,8.01901 -6.78976,14.51971 -15.16536,14.51971 v 0 c -8.37558,0 -15.16534,-6.5007 -15.16534,-14.51971 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    fillRule: "nonzero",
    d: "m 132.69423,280.22964 v 0 c 0,-8.01898 6.78976,-14.51968 15.16534,-14.51968 v 0 c 4.02211,0 7.87947,1.52975 10.72353,4.25271 2.84406,2.72299 4.44183,6.41611 4.44183,10.26697 v 0 c 0,8.01901 -6.78976,14.51971 -15.16536,14.51971 v 0 c -8.37558,0 -15.16534,-6.5007 -15.16534,-14.51971 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path35",
    fillRule: "nonzero",
    d: "m 41.597115,247.71391 v 0 c 0,-8.019 6.789757,-14.51968 15.165352,-14.51968 v 0 c 4.022102,0 7.879471,1.52974 10.723526,4.25271 2.844055,2.72296 4.441826,6.41611 4.441826,10.26697 v 0 c 0,8.019 -6.789757,14.5197 -15.165352,14.5197 v 0 c -8.375595,0 -15.165352,-6.5007 -15.165352,-14.5197 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    fillRule: "nonzero",
    d: "m 41.597115,247.71391 v 0 c 0,-8.019 6.789757,-14.51968 15.165352,-14.51968 v 0 c 4.022102,0 7.879471,1.52974 10.723526,4.25271 2.844055,2.72296 4.441826,6.41611 4.441826,10.26697 v 0 c 0,8.019 -6.789757,14.5197 -15.165352,14.5197 v 0 c -8.375595,0 -15.165352,-6.5007 -15.165352,-14.5197 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    fillRule: "nonzero",
    d: "m 86.85171,287.41864 v 0 c 0,-8.01901 6.789757,-14.51968 15.16535,-14.51968 v 0 c 4.0221,0 7.87947,1.52975 10.72353,4.25271 2.84405,2.72296 4.44182,6.41611 4.44182,10.26697 v 0 c 0,8.01898 -6.78975,14.51968 -15.16535,14.51968 v 0 c -8.375593,0 -15.16535,-6.5007 -15.16535,-14.51968 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41",
    fillRule: "nonzero",
    d: "m 86.85171,287.41864 v 0 c 0,-8.01901 6.789757,-14.51968 15.16535,-14.51968 v 0 c 4.0221,0 7.87947,1.52975 10.72353,4.25271 2.84405,2.72296 4.44182,6.41611 4.44182,10.26697 v 0 c 0,8.01898 -6.78975,14.51968 -15.16535,14.51968 v 0 c -8.375593,0 -15.16535,-6.5007 -15.16535,-14.51968 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    fillRule: "nonzero",
    d: "m 134.52493,325.5105 v 0 c 0,-8.01901 6.78976,-14.51968 15.16536,-14.51968 v 0 c 4.02209,0 7.87947,1.52975 10.72353,4.25271 2.84405,2.72296 4.44181,6.41611 4.44181,10.26697 v 0 c 0,8.01901 -6.78975,14.51968 -15.16534,14.51968 v 0 c -8.3756,0 -15.16536,-6.50067 -15.16536,-14.51968 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    fillRule: "nonzero",
    d: "m 134.52493,325.5105 v 0 c 0,-8.01901 6.78976,-14.51968 15.16536,-14.51968 v 0 c 4.02209,0 7.87947,1.52975 10.72353,4.25271 2.84405,2.72296 4.44181,6.41611 4.44181,10.26697 v 0 c 0,8.01901 -6.78975,14.51968 -15.16534,14.51968 v 0 c -8.3756,0 -15.16536,-6.50067 -15.16536,-14.51968 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47",
    fillRule: "nonzero",
    d: "m 182.21391,280.22964 v 0 c 0,-8.01898 6.78976,-14.51968 15.16536,-14.51968 v 0 c 4.02209,0 7.87946,1.52975 10.72351,4.25271 2.84406,2.72299 4.44183,6.41611 4.44183,10.26697 v 0 c 0,8.01901 -6.78976,14.51971 -15.16534,14.51971 v 0 c -8.3756,0 -15.16536,-6.5007 -15.16536,-14.51971 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    fillRule: "nonzero",
    d: "m 182.21391,280.22964 v 0 c 0,-8.01898 6.78976,-14.51968 15.16536,-14.51968 v 0 c 4.02209,0 7.87946,1.52975 10.72351,4.25271 2.84406,2.72299 4.44183,6.41611 4.44183,10.26697 v 0 c 0,8.01901 -6.78976,14.51971 -15.16534,14.51971 v 0 c -8.3756,0 -15.16536,-6.5007 -15.16536,-14.51971 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51",
    fillRule: "nonzero",
    d: "m 184.04462,325.5105 v 0 c 0,-8.01901 6.78976,-14.51968 15.16536,-14.51968 v 0 c 4.02209,0 7.87947,1.52975 10.72353,4.25271 2.84405,2.72296 4.44181,6.41611 4.44181,10.26697 v 0 c 0,8.01901 -6.78975,14.51968 -15.16534,14.51968 v 0 c -8.3756,0 -15.16536,-6.50067 -15.16536,-14.51968 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53",
    fillRule: "nonzero",
    d: "m 184.04462,325.5105 v 0 c 0,-8.01901 6.78976,-14.51968 15.16536,-14.51968 v 0 c 4.02209,0 7.87947,1.52975 10.72353,4.25271 2.84405,2.72296 4.44181,6.41611 4.44181,10.26697 v 0 c 0,8.01901 -6.78975,14.51968 -15.16534,14.51968 v 0 c -8.3756,0 -15.16536,-6.50067 -15.16536,-14.51968 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path55",
    fillRule: "nonzero",
    d: "m 226.04199,242.1378 v 0 c 0,-8.01901 6.78976,-14.5197 15.16536,-14.5197 v 0 c 4.02209,0 7.87947,1.52976 10.72353,4.25273 2.84405,2.72296 4.44183,6.41611 4.44183,10.26697 v 0 c 0,8.019 -6.78977,14.51967 -15.16536,14.51967 v 0 c -8.3756,0 -15.16536,-6.50067 -15.16536,-14.51967 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path57",
    fillRule: "nonzero",
    d: "m 226.04199,242.1378 v 0 c 0,-8.01901 6.78976,-14.5197 15.16536,-14.5197 v 0 c 4.02209,0 7.87947,1.52976 10.72353,4.25273 2.84405,2.72296 4.44183,6.41611 4.44183,10.26697 v 0 c 0,8.019 -6.78977,14.51967 -15.16536,14.51967 v 0 c -8.3756,0 -15.16536,-6.50067 -15.16536,-14.51967 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path59",
    fillRule: "nonzero",
    d: "m 227.8727,287.41864 v 0 c 0,-8.01901 6.78976,-14.51968 15.16536,-14.51968 v 0 c 4.02211,0 7.87947,1.52975 10.72353,4.25271 2.84407,2.72296 4.44181,6.41611 4.44181,10.26697 v 0 c 0,8.01898 -6.78975,14.51968 -15.16534,14.51968 v 0 c -8.3756,0 -15.16536,-6.5007 -15.16536,-14.51968 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path61",
    fillRule: "nonzero",
    d: "m 227.8727,287.41864 v 0 c 0,-8.01901 6.78976,-14.51968 15.16536,-14.51968 v 0 c 4.02211,0 7.87947,1.52975 10.72353,4.25271 2.84407,2.72296 4.44181,6.41611 4.44181,10.26697 v 0 c 0,8.01898 -6.78975,14.51968 -15.16534,14.51968 v 0 c -8.3756,0 -15.16536,-6.5007 -15.16536,-14.51968 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path63",
    fillRule: "nonzero",
    d: "m 272.41733,202.43307 v 0 c 0,-8.019 6.78976,-14.51968 15.16534,-14.51968 v 0 c 4.0221,0 7.87949,1.52974 10.72354,4.25271 2.84406,2.72296 4.44181,6.41611 4.44181,10.26697 v 0 c 0,8.019 -6.78974,14.51968 -15.16535,14.51968 v 0 c -8.37558,0 -15.16534,-6.50068 -15.16534,-14.51968 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path65",
    fillRule: "nonzero",
    d: "m 272.41733,202.43307 v 0 c 0,-8.019 6.78976,-14.51968 15.16534,-14.51968 v 0 c 4.0221,0 7.87949,1.52974 10.72354,4.25271 2.84406,2.72296 4.44181,6.41611 4.44181,10.26697 v 0 c 0,8.019 -6.78974,14.51968 -15.16535,14.51968 v 0 c -8.37558,0 -15.16534,-6.50068 -15.16534,-14.51968 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path67",
    fillRule: "nonzero",
    d: "m 274.24802,247.71391 v 0 c 0,-8.019 6.78976,-14.51968 15.16537,-14.51968 v 0 c 4.0221,0 7.87946,1.52974 10.72352,4.25271 2.84405,2.72296 4.44183,6.41611 4.44183,10.26697 v 0 c 0,8.019 -6.78976,14.5197 -15.16534,14.5197 v 0 c -8.37561,0 -15.16538,-6.5007 -15.16538,-14.5197 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path69",
    fillRule: "nonzero",
    d: "m 274.24802,247.71391 v 0 c 0,-8.019 6.78976,-14.51968 15.16537,-14.51968 v 0 c 4.0221,0 7.87946,1.52974 10.72352,4.25271 2.84405,2.72296 4.44183,6.41611 4.44183,10.26697 v 0 c 0,8.019 -6.78976,14.5197 -15.16534,14.5197 v 0 c -8.37561,0 -15.16538,-6.5007 -15.16538,-14.5197 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path71",
    fillRule: "nonzero",
    d: "m 195.9685,149.79527 31.9055,15.16536 -31.9055,15.16534 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path73",
    fillRule: "nonzero",
    d: "m 195.9685,149.79527 31.9055,15.16536 -31.9055,15.16534 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path75",
    fillRule: "nonzero",
    d: "m 101.35433,159.3832 v 0 c 0,-40.76469 32.99697,-73.81101 73.70078,-73.81101 v 0 c 19.54666,0 38.29276,7.776489 52.11433,21.61874 13.82158,13.84226 21.58646,32.61637 21.58646,52.19227 v 0 c 0,40.76471 -32.99696,73.81104 -73.70079,73.81104 v 0 c -40.70381,0 -73.70078,-33.04633 -73.70078,-73.81104 z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path77",
    fillRule: "nonzero",
    d: "m 101.35433,159.3832 v 0 c 0,-40.76469 32.99697,-73.81101 73.70078,-73.81101 v 0 c 19.54666,0 38.29276,7.776489 52.11433,21.61874 13.82158,13.84226 21.58646,32.61637 21.58646,52.19227 v 0 c 0,40.76471 -32.99696,73.81104 -73.70079,73.81104 v 0 c -40.70381,0 -73.70078,-33.04633 -73.70078,-73.81104 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path79",
    fillRule: "nonzero",
    d: "M 15.262467,17.706038 H 125.15223 v 54.83464 H 15.262467 Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path81",
    fillRule: "nonzero",
    d: "M 15.262467,17.706038 H 125.15223 v 54.83464 H 15.262467 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path83",
    fillRule: "nonzero",
    d: "M 15.262467,72.65354 54.947507,18.5748",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path85",
    fillRule: "nonzero",
    d: "M 15.262467,72.65354 54.947507,18.5748",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path87",
    fillRule: "nonzero",
    d: "M 37.56649,72.65354 77.251533,18.5748",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path89",
    fillRule: "nonzero",
    d: "M 37.56649,72.65354 77.251533,18.5748",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path91",
    fillRule: "nonzero",
    d: "M 59.870514,72.65354 99.555557,18.5748",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path93",
    fillRule: "nonzero",
    d: "M 59.870514,72.65354 99.555557,18.5748",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path95",
    fillRule: "nonzero",
    d: "M 82.17454,72.65354 121.85958,18.5748",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path97",
    fillRule: "nonzero",
    d: "M 82.17454,72.65354 121.85958,18.5748",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path99",
    fillRule: "nonzero",
    d: "m 216.86351,16.633858 h 109.88975 v 54.83465 H 216.86351 Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path101",
    fillRule: "nonzero",
    d: "m 216.86351,16.633858 h 109.88975 v 54.83465 H 216.86351 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path103",
    fillRule: "nonzero",
    d: "M 216.86351,71.58137 256.54855,17.502627",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path105",
    fillRule: "nonzero",
    d: "M 216.86351,71.58137 256.54855,17.502627",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path107",
    fillRule: "nonzero",
    d: "M 239.16754,71.58137 278.85257,17.502627",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path109",
    fillRule: "nonzero",
    d: "M 239.16754,71.58137 278.85257,17.502627",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path111",
    fillRule: "nonzero",
    d: "M 261.47156,71.58137 301.15662,17.502627",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path113",
    fillRule: "nonzero",
    d: "M 261.47156,71.58137 301.15662,17.502627",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path115",
    fillRule: "nonzero",
    d: "M 283.7756,71.58137 323.46063,17.502627",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path117",
    fillRule: "nonzero",
    d: "M 283.7756,71.58137 323.46063,17.502627",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 20,
      fontFamily: "'DejaVu Sans', sans-serif",
      textAnchor: "middle",
      fill: "#000000"
    },
    id: "text123",
    "aria-label": "UP"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path133",
    d: "m 162.37891,95.419922 h 1.98242 v 8.857418 q 0,2.34375 0.84961,3.37891 0.84961,1.02539 2.7539,1.02539 1.89453,0 2.74414,-1.02539 0.84961,-1.03516 0.84961,-3.37891 v -8.857418 h 1.98243 v 9.101558 q 0,2.85157 -1.41602,4.30665 -1.40625,1.45507 -4.16016,1.45507 -2.76367,0 -4.17968,-1.45507 -1.40625,-1.45508 -1.40625,-4.30665 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path135",
    d: "m 179.22461,97.041016 v 5.478514 h 2.48047 q 1.37695,0 2.1289,-0.71289 0.75196,-0.71289 0.75196,-2.031249 0,-1.308594 -0.75196,-2.021485 -0.75195,-0.71289 -2.1289,-0.71289 z m -1.97266,-1.621094 h 4.45313 q 2.45117,0 3.70117,1.113281 1.25977,1.103516 1.25977,3.242188 0,2.158199 -1.25977,3.261719 -1.25,1.10352 -3.70117,1.10352 h -2.48047 V 110 h -1.97266 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedyKnobComponent);
export default __webpack_public_path__ + "static/media/NeedyKnobComponent.f66c830be5428796dd1bd73e07ce95a5.svg";
export { ForwardRef as ReactComponent };